import { Injectable } from '@angular/core';
import { HttpHandler, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { LoadingService } from './local/loading.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpinterceptorService extends HttpClient {
  constructor(private httpHandler: HttpHandler, private loadingService: LoadingService) {
    super(httpHandler);
  }

  public getRequest<Response>(url: string, doNotShowLoader?: boolean): Observable<any> {
    this.showLoader(doNotShowLoader);
    return super.get(url, this.getRequestOptions()).pipe(tap((response: any) => {
      this.onSubscribeSuccess(response);
    }, (error: any) => {
      this.onSubscribeError(error);
    })).pipe(finalize(() => {
      this.onFinally();
    }));
  }

  public postRequest<Response>(url: string, body?: any, doNotShowLoader?: boolean): Observable<any> {
    this.showLoader(doNotShowLoader);
    return super.post(url, body, this.getRequestOptions()).pipe(tap((response: any) => {
      this.onSubscribeSuccess(response);
    }, (error: any) => {
      this.onSubscribeError(error);
    })).pipe(finalize(() => {
      this.onFinally();
    }));
  }

  public putRequest<Response>(url: string, body: any, doNotShowLoader?: boolean): Observable<any> {
    this.showLoader(doNotShowLoader);
    return super.put(url, body, this.getRequestOptions()).pipe(tap((response: any) => {
      this.onSubscribeSuccess(response);
    }, (error: any) => {
      this.onSubscribeError(error);
    })).pipe(finalize(() => {
      this.onFinally();
    }));
  }

  public deleteRequest<Response>(url: string, doNotShowLoader?: boolean): Observable<any> {
    this.showLoader(doNotShowLoader);
    return super.delete(url, this.getRequestOptions()).pipe(tap((response: any) => {
      this.onSubscribeSuccess(response);
    }, (error: any) => {
      this.onSubscribeError(error);
    })).pipe(finalize(() => {
      this.onFinally();
    }));
  }


  private getRequestOptions() {
    let token = environment.authToken; 
    let httpOptions = {
      headers: new HttpHeaders({})
    };
    if (token) {
      httpOptions.headers = httpOptions.headers.set('Authorization', token)
      httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
    }
    return httpOptions;
  }

  private showLoader(doNotShowLoader?: boolean) {
    if (!doNotShowLoader)
      this.loadingService.isLoading.next(true);
  }

  private hideLoader() {
    this.loadingService.isLoading.next(false);
  }

  private onFinally() {
    this.hideLoader();
  }
  private onSubscribeError(error: any) {
    this.hideLoader();
  }
  private onSubscribeSuccess(response: any) {
    this.hideLoader();
  }
}
